<template>
  <div class="appwebbox">
    <div class="pc-page-cont">
      <video
        src="https://lm8qlnns.7exgow.pro/xhs/web-new.mp4"
        poster="@/assets/xhs/12.jpg"
        autoplay
        muted
        loop
        playsinline
        webkit-playsinline
        class="videobox"
      ></video>
    </div>
    <div class="fixbox">
      <div class="headerbox">
        <div><img src="@/assets/xhs/applogo.png" alt="" /></div>
        <a :href="grouplink" target="_blank"
          ><img src="@/assets/xhs/10.png"
        /></a>
      </div>
      <div class="contentbox">
        <div class="imgbox flex just-center">
          <img src="@/assets/xhs/4.png" />
        </div>
        <a
          v-if="app_download_url"
          :href="app_download_url"
          @click="handleDownload"
          class="down-box mt-30 mb-30 flex just-center"
          ><img src="@/assets/xhs/9.png"
        /></a>
        <a
          v-else
          href="javascript:void(0)"
          class="down-box mt-30 mb-30 flex just-center"
          ><img src="@/assets/xhs/9.png"
        /></a>
        <div v-if="platform == 'ios'" class="footer-info flex just-center">
          *苹果手机请使用自带Safari浏览器
        </div>
      </div>
    </div>
    <jiao-cheng ref="jiaochengRef"></jiao-cheng>
    <dialog-tip></dialog-tip>
  </div>
</template>

<script>
import axios from "axios";
import DialogTip from "@/components/DialogTip.vue";
import JiaoCheng from "@/components/JiaoCheng.vue";
import { getDevType } from "@/utils";

export default {
  data() {
    return {
      platform: "",
      app_download_url: "",
      grouplink:
        "https://chat.chatra.io/?isModern=true&NXdc=DSAD5wdTsRE#hostId=HuzJ3rhwFb5LxdsK3&isModern=true&NXdc=DSAD5wdTsRE",
    };
  },
  props: {
    config: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: {
    JiaoCheng,
    DialogTip,
  },
  methods: {
    async handleDownload() {
      const dev = getDevType();
      const url = new URL(window.location.href);
      const dc = url.searchParams.get("dc") || "";
      const pc = url.searchParams.get("pc") || "";
      const terminal = dev;
      const domain = window.location.href;
      const data = {
        appId: 1,
        dc,
        pc,
        domain,
        terminal,
      };
      await axios.post(
        "https://ym6lzt.6rkdefoo.ink/plm/okn/ijb/vl0gpuBNWklJwcv1",
        data
      );
      this.$refs.jiaochengRef.handleOpen();
      return;
    },
    // 加载下载页面
    async loadDownloadURL() {
      try {
        const dev = getDevType();
        const url = new URL(window.location.href);
        const dc = url.searchParams.get("dc") || "";
        const pc = url.searchParams.get("pc") || "";
        const domain = window.location.href;
        const data = {
          appId: 1,
          dc,
          pc,
          domain,
        };
        // 请求下载链接
        const res = await axios.post(
          "https://ym6lzt.6rkdefoo.ink/plm/okn/ijb/nuS0EDXSczKgf3Xh",
          data
        );
        if (res.data.code == 200) {
          // 复制到剪贴板
          this.fnCopy(JSON.stringify(data));
          if (dev == "ios") {
            this.app_download_url = res.data.data.iosDownUrl;
          } else {
            this.app_download_url = res.data.data.androidDownUrl;
          }
        } else {
          this.app_download_url = this.grouplink;
        }
      } catch (e) {
        this.app_download_url = this.grouplink;
      }
    },
    fnCopy(copyText) {
      navigator.clipboard
        .writeText(copyText)
        .then(() => {})
        .catch(() => {
          const input = document.createElement("input");
          document.body.appendChild(input);
          input.setAttribute("value", copyText);
          input.select();
          if (document.execCommand("copy")) {
            document.execCommand("copy");
          }
          document.body.removeChild(input);
          console.log("复制成功");
        });
    },
  },
  created() {
    this.loadDownloadURL();
    this.platform = getDevType();
  },
  mounted() {},
};
</script>
<style lang="scss">
.pc-page-cont {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  z-index: -1;

  .videobox {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    min-width: 100%;
    min-height: 100%;
    width: auto;
    height: auto;
    object-fit: cover;
    z-index: -1;
  }
}

.fixbox {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 20px;
  z-index: 10;

  .headerbox {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .contentbox {
    position: fixed;
    text-align: center;
    bottom: 0;
    left: 0;
    right: 0;

    .footer-info {
      background: #000;
      height: 30px;
      line-height: 30px;
      font-size: 12px;
    }
  }
}
</style>
